import LoginForm from "../Login/LoginForm";

import logo from "../../assets/img/png/logo/alea-login-logo.png";

const LoginPage = () => {
  return (
    <div className="login">
      <div className="logo">
        <img src={logo} alt="logo"></img>
      </div>
      <LoginForm></LoginForm>
      <footer>
        Alea Control Management System<br></br>Always be in Control
      </footer>
    </div>
  );
};

export default LoginPage;
